"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLOOR_ENTITY_ID = void 0;
exports.FLOOR_ENTITY_ID = "0".repeat(24); // NOTE THAT THIS MUST MATCH THE ONE GENERATED IN THE API
